"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _i18n = require("@/api/i18n");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var statusDataCache = {};
var statusPendingCache = {};
var _default2 = exports.default = {
  name: 'MultiLangMaintainCore',
  props: {
    title: {
      type: String,
      default: '多语言维护'
    },
    buttonText: {
      type: String,
      default: '多语言维护'
    },
    dialogWidth: {
      type: String,
      default: '1320px'
    },
    bizId: {
      type: Number,
      required: true
    },
    bizType: {
      type: String,
      required: true
    },
    sourceLangCode: {
      type: String,
      default: 'zh-CN'
    },
    loadDetail: {
      type: Function,
      required: true
    },
    beforeSave: {
      type: Function,
      default: null
    },
    saveSource: {
      type: Function,
      default: null
    },
    maintained: {
      type: Boolean,
      default: false
    },
    pageBizIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    pageDataVersion: {
      type: Number,
      default: 0
    },
    optionalFieldKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      saveLoading: false,
      languageList: [],
      fieldItems: [],
      translations: {},
      activeLangCode: '',
      statusMap: {},
      originalSourceSnapshot: {},
      sourceDetail: null
    };
  },
  computed: {
    effectiveMaintained: function effectiveMaintained() {
      if (this.statusMap && Object.prototype.hasOwnProperty.call(this.statusMap, this.bizId)) {
        return this.statusMap[this.bizId] === true;
      }
      return this.maintained === true;
    },
    statusCacheKey: function statusCacheKey() {
      var ids = (this.pageBizIds || []).filter(Boolean).map(function (id) {
        return Number(id);
      }).sort(function (a, b) {
        return a - b;
      });
      return "".concat(this.bizType, "__").concat(ids.join(','));
    },
    editableLanguageList: function editableLanguageList() {
      var _this = this;
      return (this.languageList || []).filter(function (lang) {
        return lang.langCode !== _this.sourceLangCode;
      });
    },
    defaultLangName: function defaultLangName() {
      var _this2 = this;
      var target = (this.languageList || []).find(function (item) {
        return item.langCode === _this2.sourceLangCode;
      });
      return target ? target.langName : '中文';
    },
    currentLangName: function currentLangName() {
      var _this3 = this;
      var current = this.editableLanguageList.find(function (lang) {
        return lang.langCode === _this3.activeLangCode;
      });
      return current ? current.langName : '当前语言';
    }
  },
  methods: {
    setActiveLangCode: function setActiveLangCode(langCode) {
      this.activeLangCode = langCode || '';
    },
    openDialog: function () {
      var _openDialog = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$Promise$all, _yield$Promise$all2, languages, defaults;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.dialogVisible = true;
              this.loading = true;
              _context.prev = 2;
              _context.next = 5;
              return Promise.all([(0, _i18n.i18nLanguagesApi)(), this.loadDetail(this.bizId)]);
            case 5:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              languages = _yield$Promise$all2[0];
              defaults = _yield$Promise$all2[1];
              this.languageList = Array.isArray(languages) ? languages : [];
              this.fieldItems = Array.isArray(defaults.fieldItems) ? defaults.fieldItems : [];
              this.translations = defaults.translations || {};
              this.sourceDetail = defaults.sourceDetail != null ? defaults.sourceDetail : null;
              this.activeLangCode = this.editableLanguageList.length > 0 ? this.editableLanguageList[0].langCode : '';
              this.initMissingLanguageValue();
              this.originalSourceSnapshot = this.buildSourceSnapshot();
              _context.next = 21;
              break;
            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](2);
              this.$message.error(_context.t0.message || '加载多语言数据失败');
            case 21:
              _context.prev = 21;
              this.loading = false;
              return _context.finish(21);
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 18, 21, 24]]);
      }));
      function openDialog() {
        return _openDialog.apply(this, arguments);
      }
      return openDialog;
    }(),
    initMissingLanguageValue: function initMissingLanguageValue() {
      var _this4 = this;
      this.fieldItems.forEach(function (field) {
        if (!_this4.translations[field.fieldKey]) {
          _this4.$set(_this4.translations, field.fieldKey, {});
        }
        _this4.languageList.forEach(function (lang) {
          if (_this4.translations[field.fieldKey][lang.langCode] === undefined) {
            _this4.$set(_this4.translations[field.fieldKey], lang.langCode, '');
          }
        });
      });
    },
    getSourceValue: function getSourceValue(item) {
      var fieldKey = item ? item.fieldKey : '';
      if (fieldKey && this.translations[fieldKey] && this.translations[fieldKey][this.sourceLangCode] !== undefined) {
        return this.translations[fieldKey][this.sourceLangCode] || '';
      }
      return item && item.sourceValue ? item.sourceValue : '';
    },
    getCurrentValue: function getCurrentValue(fieldKey) {
      if (!this.translations[fieldKey]) {
        return '';
      }
      var val = this.translations[fieldKey][this.activeLangCode];
      return val === undefined || val === null ? '' : val;
    },
    setCurrentValue: function setCurrentValue(fieldKey, value) {
      if (!this.translations[fieldKey]) {
        this.$set(this.translations, fieldKey, {});
      }
      this.$set(this.translations[fieldKey], this.activeLangCode, value || '');
    },
    setSourceValue: function setSourceValue(fieldKey, value) {
      if (!this.translations[fieldKey]) {
        this.$set(this.translations, fieldKey, {});
      }
      this.$set(this.translations[fieldKey], this.sourceLangCode, value || '');
    },
    buildSourceSnapshot: function buildSourceSnapshot() {
      var _this5 = this;
      var snapshot = {};
      this.fieldItems.forEach(function (field) {
        snapshot[field.fieldKey] = _this5.getSourceValue(field);
      });
      return snapshot;
    },
    isSourceChanged: function isSourceChanged() {
      var _this6 = this;
      var current = this.buildSourceSnapshot();
      return this.fieldItems.some(function (field) {
        var key = field.fieldKey;
        return (_this6.originalSourceSnapshot[key] || '') !== (current[key] || '');
      });
    },
    buildSaveTranslations: function buildSaveTranslations() {
      var _this7 = this;
      var result = {};
      Object.keys(this.translations || {}).forEach(function (fieldKey) {
        var langMap = _this7.translations[fieldKey] || {};
        var targetLangMap = {};
        Object.keys(langMap).forEach(function (langCode) {
          if (langCode === _this7.sourceLangCode) {
            return;
          }
          targetLangMap[langCode] = langMap[langCode];
        });
        if (Object.keys(targetLangMap).length > 0) {
          result[fieldKey] = targetLangMap;
        }
      });
      return result;
    },
    normalizeTranslationValue: function normalizeTranslationValue(value) {
      var raw = value == null ? '' : String(value);
      return raw.replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, '').replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '').replace(/<[^>]+>/g, '').replace(/&nbsp;/gi, ' ').trim();
    },
    validateRequiredTranslations: function validateRequiredTranslations() {
      if (!this.fieldItems.length) {
        return true;
      }
      var langList = [{
        langCode: this.sourceLangCode,
        langName: this.defaultLangName
      }].concat(_toConsumableArray(this.editableLanguageList));
      for (var i = 0; i < langList.length; i++) {
        var lang = langList[i];
        for (var j = 0; j < this.fieldItems.length; j++) {
          var field = this.fieldItems[j];
          if ((this.optionalFieldKeys || []).includes(field.fieldKey)) {
            continue;
          }
          var map = this.translations[field.fieldKey] || {};
          var normalized = this.normalizeTranslationValue(map[lang.langCode]);
          if (!normalized) {
            if (lang.langCode !== this.sourceLangCode) {
              this.activeLangCode = lang.langCode;
            }
            this.$message.error("".concat(lang.langName, " \u7684\u201C").concat(field.fieldLabel, "\u201D\u4E0D\u80FD\u4E3A\u7A7A"));
            return false;
          }
        }
      }
      return true;
    },
    loadStatusMap: function () {
      var _loadStatusMap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var force,
          ids,
          key,
          _map,
          requestPromise,
          map,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              force = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
              ids = (this.pageBizIds || []).filter(Boolean);
              if (!(!this.bizType || !ids.length)) {
                _context2.next = 5;
                break;
              }
              this.statusMap = {};
              return _context2.abrupt("return");
            case 5:
              key = this.statusCacheKey;
              if (!statusPendingCache[key]) {
                _context2.next = 12;
                break;
              }
              _context2.next = 9;
              return statusPendingCache[key];
            case 9:
              _map = _context2.sent;
              this.statusMap = _map || {};
              return _context2.abrupt("return");
            case 12:
              if (!(!force && statusDataCache[key])) {
                _context2.next = 15;
                break;
              }
              this.statusMap = statusDataCache[key];
              return _context2.abrupt("return");
            case 15:
              if (force) {
                delete statusDataCache[key];
              }
              requestPromise = (0, _i18n.i18nBizStatusBatchApi)({
                bizType: this.bizType,
                bizIds: ids.join(',')
              }).then(function (res) {
                var map = res || {};
                statusDataCache[key] = map;
                return map;
              }).catch(function () {
                return {};
              }).finally(function () {
                delete statusPendingCache[key];
              });
              statusPendingCache[key] = requestPromise;
              _context2.next = 20;
              return requestPromise;
            case 20:
              map = _context2.sent;
              this.statusMap = map || {};
            case 22:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loadStatusMap() {
        return _loadStatusMap.apply(this, arguments);
      }
      return loadStatusMap;
    }(),
    handleSave: function () {
      var _handleSave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.saveLoading = true;
              _context3.prev = 1;
              if (this.validateRequiredTranslations()) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return");
            case 4:
              _context3.next = 6;
              return this.$confirm('请确认所有国家语言已维护正确再提交！', '提交确认', {
                type: 'warning',
                confirmButtonText: '确认提交',
                cancelButtonText: '取消'
              });
            case 6:
              if (!this.beforeSave) {
                _context3.next = 12;
                break;
              }
              _context3.next = 9;
              return this.beforeSave({
                fieldItems: this.fieldItems,
                languageList: this.languageList,
                editableLanguageList: this.editableLanguageList,
                activeLangCode: this.activeLangCode,
                sourceLangCode: this.sourceLangCode,
                translations: this.translations,
                getSourceValue: this.getSourceValue,
                setActiveLangCode: this.setActiveLangCode
              });
            case 9:
              ok = _context3.sent;
              if (!(ok === false)) {
                _context3.next = 12;
                break;
              }
              return _context3.abrupt("return");
            case 12:
              if (!(this.saveSource && this.isSourceChanged())) {
                _context3.next = 15;
                break;
              }
              _context3.next = 15;
              return this.saveSource({
                bizId: this.bizId,
                bizType: this.bizType,
                fieldItems: this.fieldItems,
                translations: this.translations,
                sourceLangCode: this.sourceLangCode,
                sourceDetail: this.sourceDetail,
                originalSourceSnapshot: this.originalSourceSnapshot
              });
            case 15:
              _context3.next = 17;
              return (0, _i18n.i18nSaveBizContentApi)({
                bizType: this.bizType,
                bizId: this.bizId,
                contentJson: JSON.stringify(this.buildSaveTranslations()),
                confirmed: true
              });
            case 17:
              this.$message.success('保存成功');
              this.dialogVisible = false;
              _context3.next = 21;
              return this.loadStatusMap(true);
            case 21:
              this.$emit('saved');
              _context3.next = 27;
              break;
            case 24:
              _context3.prev = 24;
              _context3.t0 = _context3["catch"](1);
              if (_context3.t0 && _context3.t0 !== 'cancel' && _context3.t0 !== 'close') {
                this.$message.error(_context3.t0.message || '保存失败');
              }
            case 27:
              _context3.prev = 27;
              this.saveLoading = false;
              return _context3.finish(27);
            case 30:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 24, 27, 30]]);
      }));
      function handleSave() {
        return _handleSave.apply(this, arguments);
      }
      return handleSave;
    }()
  },
  watch: {
    pageBizIds: {
      deep: true,
      immediate: true,
      handler: function handler() {
        this.loadStatusMap(false);
      }
    },
    bizType: {
      immediate: true,
      handler: function handler() {
        this.loadStatusMap(false);
      }
    },
    pageDataVersion: function pageDataVersion() {
      this.loadStatusMap(true);
    }
  }
};